import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import BreweryDetail from './BreweryDetail';
import NotFound from './NotFound';
import './index.css';
import {Router, Route, browserHistory} from 'react-router';



var routes = (
    <Router history={browserHistory}>
        
        <Route path="/" component={App}/>
           
        <Route path="/brewery/:breweryId" component={BreweryDetail}/>
        <Route path="*" component={NotFound}/>
        
       
    </Router>
)

ReactDOM.render(routes, document.getElementById('root'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/